/** @format */

import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import alibaba from "../assets/images/parteners/alibaba.png";
import amazon from "../assets/images/parteners/amazon.png";
import haojue from "../assets/images/parteners/haojue.png";
import mastercard from "../assets/images/parteners/mastercard.png";
import mmre from "../assets/images/parteners/mmre.png";
import moov from "../assets/images/parteners/moov.png";
import otr from "../assets/images/parteners/otr.png";
import portlome from "../assets/images/parteners/portlome.png";
import renz from "../assets/images/parteners/renz.png";
import superramco from "../assets/images/parteners/superramco.png";
import tesla from "../assets/images/parteners/tesla.png";
import toyota from "../assets/images/parteners/toyota.png";
import visa from "../assets/images/parteners/visa.png";
import yastogo from "../assets/images/parteners/yastogo.png";

const responsive = {
  superLargeDesktop: { breakpoint: { max: 4000, min: 3000 }, items: 7 },
  desktop: { breakpoint: { max: 3000, min: 1024 }, items: 6 },
  tablet: { breakpoint: { max: 1024, min: 640 }, items: 4 },
  mobile: { breakpoint: { max: 640, min: 440 }, items: 3 },
  smmobile: { breakpoint: { max: 440, min: 0 }, items: 2 },
};

const Partners = [
  { name: "Toyota TG", image: toyota },
  { name: "Alibaba", image: alibaba },
  { name: "Visa Card", image: visa },
  { name: "MasterCard", image: mastercard },
  { name: "MMRE", image: mmre },
  { name: "Moov Africa", image: moov },
  { name: "Haojue Motor", image: haojue },
  { name: "Amazon", image: amazon },
  { name: "RENZ", image: renz },
  { name: "Yas Togo", image: yastogo },
  { name: "OTR", image: otr },
  { name: "Port Autonome", image: portlome },
  { name: "Tesla", image: tesla },
  { name: "Super Ramco", image: superramco },
];

const PartnerCard = ({ partner }) => (
  <motion.div
    whileHover={{ y: -4, scale: 1.03 }}
    transition={{ duration: 0.25 }}
    className='mx-2 h-[110px] bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-md overflow-hidden flex flex-col items-center justify-between p-3 cursor-pointer group'
  >
    <div className='flex-1 flex items-center justify-center w-full'>
      <img
        className='max-h-[60px] w-full object-contain transition-transform duration-300 group-hover:scale-105'
        src={partner.image}
        alt={partner.name}
        loading='lazy'
      />
    </div>
    <span className='mt-2 text-[10px] font-semibold text-gray-500 uppercase tracking-wider truncate w-full text-center group-hover:text-orange-500 transition-colors duration-200'>
      {partner.name}
    </span>
  </motion.div>
);

const NosPartenaires = () => {
  const { t } = useTranslation();

  return (
    <div className='w-[95%] mx-auto'>
      {/* Header */}
      <div className='flex flex-col items-center mb-8'>
        <p className='text-xs font-semibold tracking-[0.25em] text-orange-500 uppercase mb-2'>
          Ils nous font confiance
        </p>
        <h2 className='text-2xl font-bold text-gray-800'>
          {t("Those who thrust us").toUpperCase()}
        </h2>
        <div className='mt-3 w-12 h-1 rounded-full bg-gradient-to-r from-orange-500 to-yellow-400' />
      </div>

      {/* Carousel */}
      <Carousel
        swipeable
        draggable
        showDots={false}
        responsive={responsive}
        infinite
        autoPlay
        autoPlaySpeed={2200}
        transitionDuration={600}
        arrows={false}
        keyBoardControl
        itemClass='px-1'
      >
        {Partners.map((partner, i) => (
          <PartnerCard key={i} partner={partner} />
        ))}
      </Carousel>

      {/* Bottom fade line */}
      <div className='mt-8 h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent' />
    </div>
  );
};

export default NosPartenaires;
